import React, { Fragment, useState, useEffect } from 'react';
import {
    Grid,
    Box,
    Typography,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TextField,
    InputAdornment,
    Paper,
    IconButton,
    Dialog,
    tableCellClasses,
} from '@mui/material';
import ClientServices from 'services/Client';
import VehicleBookingServices from 'services/VehicleBooking';
import InputField from 'components/Input';
import DatePicker from 'components/DatePicker';
import { PrimaryButton } from 'components/Buttons';
import Colors from 'assets/Style/Colors';
import { SearchIcon, FontFamily } from 'assets';
import SelectField from 'components/Select';
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";
import { makeStyles } from "@mui/styles";
import moment from 'moment';
import { CancelOutlined } from "@mui/icons-material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ErrorToaster, SuccessToaster } from 'components/Toaster';
import VendorServices from 'services/Vendor';
import UserServices from 'services/User';


const Row = styled(TableRow)({ border: 0 });
const Cell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 14,
        fontFamily: FontFamily.NunitoRegular,
        border: 0,
        textAlign: "center",
        whiteSpace: "nowrap",
        background: Colors.primary,
        color: Colors.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontFamily: FontFamily.NunitoRegular,
        textAlign: "center",
        textWrap: "nowrap",
        padding: "5px !important",
        ".MuiBox-root": {
            display: "flex",
            gap: "6px",
            alignItems: "center",
            justifyContent: "center",
            ".MuiBox-root": {
                cursor: "pointer",
            },
        },
        svg: {
            width: "auto",
            height: "24px",
        },
        ".MuiTypography-root": {
            textTransform: "capitalize",
            fontFamily: FontFamily.NunitoRegular,
            textWrap: "nowrap",
        },
        ".MuiButtonBase-root": {
            padding: "8px",
            width: "28px",
            height: "28px",
        },
    },
}));

const useStyles = makeStyles({
    loaderWrap: {
        display: "flex",
        height: 100,
    },
});

const UpdateDamages = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { id } = useParams();
    const [selectedDate, setSelectedDate] = useState(null);
    const [vehicles, setVehicles] = useState([]);
    const [rows, setRows] = useState([]);
    const [notes, setNotes] = useState({});
    const [loading, setLoading] = useState(false);
    const { register, formState: { errors }, getValues: getValues1 } = useForm();
    const [isSearching, setIsSearching] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [selectedRows, setSelectedRows] = useState(location.state?.selectedRows || []);
    const [filters, setFilters] = useState({});
    const [pageLimit, setPageLimit] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const [bookingCustomers, setBookingCustomers] = useState([]);
    const [selectedBookingCustomer, setSelectedBookingCustomer] = useState(null);

    const [vendors, setVendors] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [damagesData, setDamagesData] = useState(null);
    const [staff, setStaff] = useState([]);
    
    const getVendorDropdown = async () => {
        try {
            const { data } = await VendorServices.getVendorDropdown();
            setVendors(data?.vendors);
        } catch (error) {
            ErrorToaster(error);
        }
    };

    const getUsers = async (page, limit, search) => {
            try {
                const params = { page: 1, limit: 100, search };
                const { data } = await UserServices.getUsers(params)
                const rows = data?.users?.rows ?? [];
    
                const staffOnly = rows.filter(user => user?.user_type_id === 'S');
    
                const staffData = staffOnly.map(user => ({
                    id: user?.id,
                    name: user?.name,
                }));
    
                setStaff(staffData);
    
            } catch (error) {
                ErrorToaster(error)
            }
        }
    
    const getAllSLPVehicles = async (page, limit, filter) => {
        try {
            const Page = page ?? currentPage;
            const Limit = limit ?? pageLimit;
            const Filter = { ...filters, ...filter };

            const params = { page: Page, limit: Limit, ...Filter };
            const { data } = await ClientServices.getSLPVehicles(params);

            if (filter?.search) {
                const matchedVehicle = data.vehicles.find((v) => v.vin === filter.search);

                if (!matchedVehicle) {
                    ErrorToaster("VIN not found.");
                    return;
                }

                if (rows.length >= 1) {
                    ErrorToaster("Only one VIN can be added. Remove the existing VIN to add another.");
                    return;
                }

                if (!rows.some(r => r.vin === matchedVehicle.vin)) {
                    const newRow = {
                        id: matchedVehicle.id,
                        customer: matchedVehicle.customer?.name,
                        buyer_id: matchedVehicle.buyer_id,
                        buyer_name: matchedVehicle.buyer?.name,
                        vin: matchedVehicle.vin,
                        lot: matchedVehicle.lot_number,
                        make: matchedVehicle.veh_make?.name || '',
                        model: matchedVehicle.veh_model?.name || '',
                        color: matchedVehicle.color || "",
                        discount: 0,
                        damage_reason: "",
                    };
                    setRows([newRow]);
                } else {
                    ErrorToaster("This VIN is already added.");
                }
            } else {
                setVehicles(data.vehicles);
            }

            setCurrentPage(Page);
            setPageLimit(Limit);
            setFilters(Filter);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        // getBookingCustomers();
        getAllSLPVehicles();
        getVendorDropdown();
        getUsers();
    }, []);

    const handleEditClick = (row) => {
        setSelectedRows(row);
        setOpenEditModal(true);
        setNotes((prev) => ({ ...prev, [row.id]: row.notes || '' }));
    };

    const handleDiscountSChange = (id, value) => {
        setRows(prev =>
            prev.map(row => row.id === id ? { ...row, discount: value } : row)
        );
    };

    const handleDamageReasonChange = (id, value) => {
        setRows(prev =>
            prev.map(row => row.id === id ? { ...row, damage_reason: value } : row)
        );
    };

    const handleNotesChange = (e) => {
        const { value } = e.target;
        setNotes((prev) => ({
            ...prev,
            [selectedRows.id]: value,
        }));
    };

    const handleSaveNotes = () => {
        setRows((prev) =>
            prev.map((row) =>
                row.id === selectedRows.id
                    ? { ...row, notes: notes[selectedRows.id] }
                    : row
            )
        );
        setOpenEditModal(false);
    };

    const handleDelete = (vin) => {
        const updatedRows = rows.filter((row) => row.vin !== vin);
        setRows(updatedRows);
    };

    const getBookingCustomers = async (search) => {
        try {
            const params = { page: 1, limit: 50, search };
            const { data } = await VehicleBookingServices.getBookingCustomers(params);
            setBookingCustomers(
                data?.filters.map((item) => ({ id: item?.customer_id, name: item?.customer_name }))
            );
        } catch (error) {
            ErrorToaster(error);
        }
    };


    const getDamagesData = async () => {
        try {
            const { data } = await VendorServices.getDamagesDetail({ damage_id: id });
            setDamagesData(data?.damage)

        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {

        getDamagesData();
    }, []);


    const handleFilter = async (data) => {
        if (!data || isSearching) return;
        setIsSearching(true);
        try {
            await getAllSLPVehicles(1, undefined, data);
        } catch (err) {
            console.error("Search failed:", err);
        } finally {
            setIsSearching(false);
        }
    };

    const handleSubmitDamages = async () => {
        try {
            if (rows.length !== 1) {
                ErrorToaster("Please add exactly one VIN before submitting.");
                return;
            }

            const row = rows[0];

            if (!selectedVendor?.id) {
                ErrorToaster("Please select the 'Vendor Damaged By'.");
                return;
            }

            if (!selectedDate) {
                ErrorToaster("Please select a date.");
                return;
            }

            const creditAmount = Number(row.discount || 0);
            if (!(creditAmount > 0)) {
                ErrorToaster("Please enter a valid credited amount (> 0).");
                return;
            }

            if (!row.damage_reason || !row.damage_reason.trim()) {
                ErrorToaster("Please enter a Damage Reason.");
                return;
            }

            const booking_id = row?.vehicle?.booking_id ?? row.id;
            if (!booking_id) {
                ErrorToaster("Missing booking_id for this VIN.");
                return;
            }

            const payload = {
                damage_id: Number(id),
                booking_id,
                customer_id: row?.customer_id,
                vendor_id: selectedVendor?.id,
                credit_amount: creditAmount,
                reason: row?.damage_reason.trim(),
                damage_type: "general",
                is_active: true,
                booked_date: selectedDate,
                approved_by: selectedBookingCustomer?.id ?? null,
            };

            setLoading(true);

            const { data } = await VendorServices.updateDamages(payload);

            SuccessToaster("Submitted successfully.");
            navigate('/damages-list')

        } catch (e) {
            ErrorToaster(e);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (!damagesData) return;

        const b = damagesData.booking;

        const prefillRow = {
            id: b?.id ?? damagesData.booking_id,
            buyer_id: b?.buyer_id ?? b?.buyer?.id ?? null,
            buyer_name: b?.buyer?.name ?? "",
            customer: b?.customer?.name ?? '',
            customer_id: b?.customer?.id ?? '',
            vin: b?.vin ?? "",
            lot: b?.lot_number ?? "",
            make: b?.veh_make?.name ?? "",
            model: b?.veh_model?.name ?? "",
            color: b?.color ?? "",
            discount: Number(damagesData.credit_amount ?? 0),
            damage_reason: damagesData.reason ?? "",
            notes: damagesData.remarks ?? "",
        };
        setRows([prefillRow]);

        setSelectedDate(damagesData.booked_date);

        const matchedVendor =
            vendors.find(v => v.id === damagesData.vendor_id) ?? damagesData.vendor ?? null;
        setSelectedVendor(matchedVendor);

        if (damagesData.approved_by) {
            const matchedApprover =
                bookingCustomers.find(c => c.id === damagesData.approved_by) ||
                { id: damagesData.approved_by, name: b?.customer?.name ?? "Approver" };
            setSelectedBookingCustomer(matchedApprover);
        } else if (b?.customer?.id) {
            setSelectedBookingCustomer({ id: b.customer.id, name: b.customer.name });
        }
    }, [damagesData]);


    return (
        <Fragment>
            <Dialog
                open={openEditModal}
                onClose={() => setOpenEditModal(false)}
                sx={{
                    "& .MuiDialog-paper": {
                        width: "30%",
                        height: "auto",
                        borderRadius: 2,
                        py: { xs: 2, md: 4 },
                        px: { xs: 3, md: 6 },
                    },
                }}
            >
                <IconButton
                    onClick={() => setOpenEditModal(false)}
                    sx={{ position: "absolute", right: 13, top: 13 }}
                >
                    <CancelOutlined />
                </IconButton>
                <Box component={"form"}>
                    <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: "bold" }}>
                        Notes
                    </Typography>
                    <TextField
                        fullWidth
                        multiline
                        rows={1}
                        value={notes[selectedRows?.id] ?? ""}
                        onChange={handleNotesChange}
                        placeholder="Enter notes"
                    />
                    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", mt: 2 }}>
                        <PrimaryButton title="Submit" onClick={handleSaveNotes} />
                    </Box>
                </Box>
            </Dialog>

            <Grid container spacing={1} alignItems={'center'} justifyContent={'center'}>
                <Grid item xs={12} sm={12} md={11}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', mr: 4, my: 4 }}>
                        <Typography variant='h4' sx={{ color: Colors.charcoalGrey, fontFamily: FontFamily.NunitoRegular }}>
                            Update Damages
                        </Typography>
                    </Box>
                </Grid>

                {/* Filters */}
                <Grid item md={11}>
                    <Box sx={{ m: '10px 0 10px 0' }}>
                        <Grid container spacing={2} alignItems={'center'} component={'form'}>
                            <Grid item xs={12} sm={2.5} sx={{ marginTop: "5px" }}>
                                <InputField
                                    size={"small"}
                                    inputStyle={{ backgroundColor: "#f5f5f5" }}
                                    label={"Search"}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                    }}
                                    placeholder={"Search VIN"}
                                    register={register("search")}
                                />
                            </Grid>

                            <Grid item xs={12} sm={2.5}>
                                <DatePicker
                                    size={'small'}
                                    label={'Select Date'}
                                    value={selectedDate ? moment(selectedDate).toDate() : new Date()}
                                    onChange={(date) => setSelectedDate(moment(date).format('YYYY-MM-DD'))}
                                />
                            </Grid>

                            <Grid item xs={12} sm={2.5} sx={{ marginTop: '7px' }}>
                                <SelectField
                                    size={"small"}
                                    label={"Vendor Damaged By"}
                                    options={vendors}
                                    selected={selectedVendor}
                                    onSelect={(value) => setSelectedVendor(value)}
                                    error={errors?.vendor?.message}
                                    register={register("vendor")}
                                />
                            </Grid>

                            <Grid item xs={12} sm={2.5}>
                                <SelectField
                                    size={"small"}
                                    onSearch={(v) => getUsers(v)}
                                    label={"Approved By"}
                                    options={staff}
                                    selected={selectedBookingCustomer}
                                    onSelect={(value) => {
                                        setSelectedBookingCustomer(value);
                                    }}
                                    register={register("approvedBy")}
                                />
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <Box sx={{ mt: "16px" }}>
                                    <PrimaryButton
                                        onClick={() => {
                                            const searchVal = getValues1("search");
                                            if (searchVal) handleFilter({ search: searchVal });
                                        }}
                                        title="Search"
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>

                    <Box>
                        <TableContainer
                            component={Paper}
                            sx={{
                                boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                                borderRadius: 2,
                                maxHeight: "calc(100vh - 330px)",
                                mt: 2,
                            }}
                            className="table-box"
                        >
                            <Table stickyHeader sx={{ minWidth: 500 }}>
                                <TableHead>
                                    <TableRow>
                                        <Cell>Customer Name</Cell>
                                        <Cell>VIN</Cell>
                                        <Cell>LOT</Cell>
                                        <Cell>Model/Make/Color</Cell>
                                        {/* <Cell>Approved By</Cell> */}
                                        <Cell>Credited Amt $</Cell>
                                        <Cell>Damage Reason</Cell>
                                        {/* <Cell>Notes</Cell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.length > 0 ? (
                                        rows.map((row) => (
                                            <TableRow
                                                key={row.id}
                                                sx={{ bgcolor: rows.indexOf(row) % 2 !== 0 ? '#EFF8E7' : 'inherit' }}
                                            >
                                                <Cell>{row.customer}</Cell>
                                                <Cell>{row.vin}</Cell>
                                                <Cell>{row.lot}</Cell>
                                                <Cell>{row?.model}{'-'}{row.make}{'-'}{row.color}</Cell>
                                                {/* <Cell>{"-"}</Cell> */}
                                                <Cell sx={{ width: "10%" }}>
                                                    <InputField
                                                        size="small"
                                                        type="number"
                                                        value={row.discount}
                                                        onInput={(e) =>
                                                            handleDiscountSChange(row.id, parseFloat(e.target.value || 0))
                                                        }
                                                    />
                                                </Cell>
                                                {/* NEW: Damage Reason input */}
                                                <Cell sx={{ width: "22%" }}>
                                                    <InputField
                                                        size="small"
                                                        placeholder="Enter damage reason"
                                                        value={row.damage_reason}
                                                        onInput={(e) =>
                                                            handleDamageReasonChange(row.id, e.target.value)
                                                        }
                                                    />
                                                </Cell>
                                                {/* <Cell>
                                                    <Box component={"div"} onClick={() => handleEditClick(row)}>
                                                        <EditIcon />
                                                    </Box>
                                                </Cell> */}
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <Cell colSpan={11} sx={{
                                                textAlign: "center",
                                                fontWeight: "bold",
                                                fontFamily: FontFamily.NunitoRegular,
                                                fontSize: "16px",
                                            }}>
                                                <Box sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                    No Data Found
                                                </Box>
                                            </Cell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Grid>

                {/* Submit Button */}
                <Grid item md={11} justifyContent="end">
                    <Box sx={{ mt: "28px", mb: "28px", display: "flex", justifyContent: "flex-end" }}>
                        <PrimaryButton onClick={handleSubmitDamages} title="Submit" loading={loading} />
                    </Box>
                </Grid>
            </Grid>
        </Fragment>
    );
};

export default UpdateDamages;
